type EnvironmentalStressMonitoringIcon = {
    web: {
        name: string;
        style: {
            backgroundColor: string;
            color: string;
        };
        family: string;
    };
    mobile: {
        name: string;
        style: {
            backgroundColor: string;
            color: string;
        };
        family: string;
    };
};

type EnvironmentalStressMonitoringOverviewMetric = {
    name: string;
    value: number;
    unit: string;
    status: 'alarm' | 'warning' | 'normal';
    displayType: 'AVG' | 'COUNT';
    icon: EnvironmentalStressMonitoringIcon;
};

type EnvironmentalStressMonitoringPreviewNotificationItem = {
    id: number;
    type: 'warning' | 'alarm' | 'offline' | 'normal';
    time: string;
    date: string;
    title: string;
    value: number;
    unit: string;
    icons: {
        status: {
            indicator: string;
            icon: EnvironmentalStressMonitoringIcon;
        };
    };
};

type EnvironmentalStressMonitoringPreviewResponse = {
    data: {
        overview: {
            title: string;
            status: {
                label: string;
                severity: 'alarm' | 'warning' | 'normal';
                icon: EnvironmentalStressMonitoringIcon;
            };
            metrics: EnvironmentalStressMonitoringOverviewMetric[];
        };
        notifications: {
            title: string;
            alarmCount: number;
            warningCount: number;
            items: EnvironmentalStressMonitoringPreviewNotificationItem[];
        };
    };
};

export const environmentalStressMonitoringPreviewResponse: EnvironmentalStressMonitoringPreviewResponse = {
    data: {
        overview: {
            title: '30-Day Overview',
            status: {
                label: 'Warning',
                severity: 'alarm',
                icon: {
                    web: {
                        name: 'Warning',
                        style: {
                            backgroundColor: '#F5A623',
                            color: '#FFFFFF',
                        },
                        family: 'material-ui',
                    },
                    mobile: {
                        name: 'warning',
                        style: {
                            backgroundColor: '#F5A623',
                            color: '#FFFFFF',
                        },
                        family: 'material',
                    },
                },
            },
            metrics: [
                {
                    name: 'Remote Humidity',
                    value: 58,
                    unit: '%',
                    status: 'warning',
                    displayType: 'AVG',
                    icon: {
                        web: {
                            name: 'InfoOutlined',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-ui',
                        },
                        mobile: {
                            name: 'information-outline',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-community',
                        },
                    },
                },
                {
                    name: 'Remote Temperature',
                    value: 37,
                    unit: '°C',
                    status: 'warning',
                    displayType: 'AVG',
                    icon: {
                        web: {
                            name: 'InfoOutlined',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-ui',
                        },
                        mobile: {
                            name: 'information-outline',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-community',
                        },
                    },
                },
                {
                    name: 'EMC',
                    value: 8,
                    unit: '%',
                    status: 'normal',
                    displayType: 'AVG',
                    icon: {
                        web: {
                            name: 'InfoOutlined',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-ui',
                        },
                        mobile: {
                            name: 'information-outline',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-community',
                        },
                    },
                },
                {
                    name: 'Dew Point',
                    value: 18,
                    unit: '°C',
                    status: 'normal',
                    displayType: 'AVG',
                    icon: {
                        web: {
                            name: 'InfoOutlined',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-ui',
                        },
                        mobile: {
                            name: 'information-outline',
                            style: {
                                backgroundColor: '#FFFFFF',
                                color: '#007BC1',
                            },
                            family: 'material-community',
                        },
                    },
                },
            ],
        },
        notifications: {
            title: 'Notifications',
            alarmCount: 2,
            warningCount: 1,
            items: [
                {
                    id: 1,
                    type: 'alarm',
                    time: '8:21 AM',
                    date: '11/23/21',
                    title: 'High Temperature',
                    value: 70,
                    unit: '°C',
                    icons: {
                        status: {
                            indicator: '#F5A623',
                            icon: {
                                web: {
                                    name: 'NotificationsActive',
                                    style: {
                                        backgroundColor: '#F5A623',
                                        color: '#FFFFFF',
                                    },
                                    family: 'material-ui',
                                },
                                mobile: {
                                    name: 'notifications-active',
                                    style: {
                                        backgroundColor: '#F5A623',
                                        color: '#FFFFFF',
                                    },
                                    family: 'material',
                                },
                            },
                        },
                    },
                },
                {
                    id: 2,
                    type: 'alarm',
                    time: '8:21 AM',
                    date: '11/23/21',
                    title: 'High Humidity',
                    value: 40,
                    unit: '%',
                    icons: {
                        status: {
                            indicator: '#F5A623',
                            icon: {
                                web: {
                                    name: 'NotificationsActive',
                                    style: {
                                        backgroundColor: '#F5A623',
                                        color: '#FFFFFF',
                                    },
                                    family: 'material-ui',
                                },
                                mobile: {
                                    name: 'notifications-active',
                                    style: {
                                        backgroundColor: '#F5A623',
                                        color: '#FFFFFF',
                                    },
                                    family: 'material',
                                },
                            },
                        },
                    },
                },
                {
                    id: 3,
                    type: 'warning',
                    time: '12:11 AM',
                    date: '11/17/21',
                    title: 'High Temperature',
                    value: 37,
                    unit: '°C',
                    icons: {
                        status: {
                            indicator: '#F5A623',
                            icon: {
                                web: {
                                    name: 'Warning',
                                    style: {
                                        backgroundColor: '#F5A623',
                                        color: '#FFFFFF',
                                    },
                                    family: 'material-ui',
                                },
                                mobile: {
                                    name: 'warning',
                                    style: {
                                        backgroundColor: '#F5A623',
                                        color: '#FFFFFF',
                                    },
                                    family: 'material',
                                },
                            },
                        },
                    },
                },
            ],
        },
    },
};
